export const trackMetaEvent = (event, data = {}) => {
  if (window.fbq) {
    window.fbq("track", event, data);
    console.log("Meta Pixel event tracked:", event, data);
  } else {
    console.warn("Meta Pixel not initialized");
  }
};
